import styled from 'styled-components';

const S = {}

S.CommonSeoPageWrapper = styled.div`
    max-width: 1200px;
    min-height: 50vh;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    & h2 {
        margin: 40px 15px;
        color: #000000cc
    }

    & p {
        margin: 0px 15px;
        line-height: 30px;
        letter-spacing: 0px;
        font-weight: 100;
        font-size: 20px;
        text-align: justify;
        margin-bottom: 60px;

        @media (max-width: 768px) {
            font-size: 18px;
        }
    }

    a {
        text-decoration: none;
        font-weight: 700;
        color: #dc8313f7;
    }
`;

export default S;